import { filter, distinctUntilChanged, debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { DialogDetalleMovimientosConsolidadoCajaComponent } from './components/dialogDetalleMovimientosConsolidadoCaja.component';

import { ProveedorService, MenuFuncionService, TenantService, ComunidadService, ConsorcioService, MovimientoService, MonedaService, UnidadFuncionalService } from '../../../../../src/app/shared/services';

import { Comunidad, Consorcio, DialogDetalleMovimientosConsolidadoCajaRequestDto, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, Moneda, Proveedor,
  ReporteConsolidadoCajaAgrupadorConstants, SearchComunidadRequest, SearchConsorcioRequest, SearchMonedaRequest, SearchProveedorRequest, UnidadFuncional, SearchReporteConsolidadoCajaRequestDto, SearchUnidadFuncionalRequest, TenantFeatureFlags
 } from '../../../../../src/app/shared/model';

import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
  selector: 'app-reporte-consolidado-caja',
  templateUrl: './reporte-consolidado-caja.component.html',
  styleUrls: ['./reporte-consolidado-caja.component.scss']
})

export class ReporteConsolidadoCajaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isExportingDetalles: boolean = false;

  canView: boolean = false;
  canViewProveedor: boolean = false;
  canViewComunidad: boolean = false;
  canViewConsorcio: boolean = false;
  canViewPersona: boolean = false;
  canViewUf: boolean = false;

  verSeparadoEnIva: boolean = false;
  gridAllowPaging: boolean = true;

  isComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isProveedorSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  filteredProveedorList: Proveedor[];
  comunidadList: Comunidad[];
  consorcioList: Consorcio[];
  monedaList: Moneda[];
  ufList: UnidadFuncional[];

  public totalIngresos: any[];
  public totalEgresos: any[];
  public totalNetos: any[];

  campoAgrupador: number = ReporteConsolidadoCajaAgrupadorConstants.Tenant;
  camposAgrupadoresList: any[];
  isRosbaco: boolean = false;

  private readonly gridColumns = [
    { field: 'Concepto', headerText: 'Concepto', width: 120 },
    { field: 'Moneda', headerText: 'Moneda', width: 90 },
    { field: 'CuentaImputadaCodigo', headerText: 'Cuenta', width: 90 },

    { field: 'Ingresos', headerText: 'Ingresos', width: 90, format: "N2", textAlign: 'right' },
    { field: 'Egresos', headerText: 'Egresos', width: 90, format: "N2", textAlign: 'right' },
    { field: 'EgresosNeto', headerText: 'Egresos Netos', width: 90, format: "N2", textAlign: 'right' },
    { field: 'EgresosIva', headerText: 'Egresos IVA', width: 90, format: "N2", textAlign: 'right' },
    { field: 'Neto', headerText: 'Balance', width: 90, format: "N2", textAlign: 'right' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    public dialog: MatDialog,
    private router: Router,
    private menuService: MenuFuncionService,
    private proveedorService: ProveedorService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private consorcioService: ConsorcioService,
    private monedaService: MonedaService,
    private tenantService: TenantService,
    private movimientoService: MovimientoService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.REPORTE_CONSOLIDADO_CAJA).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
            this.loadView();
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            // this.onCancel();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.isRosbaco = this.sharedFunctions.isRosbacoUser();

    this.buildForm();
    this.setPermissions();

    // this.getAutocompleteProveedor();
    this.getConsorcios();
    this.getComunidades();
    this.getMonedas();
    this.getAgrupadores();

    var filtros = this.sharedFunctions.getReporteFiltros("app-reporteConsolidadoCaja");
    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }

    this.setQueryParams();

    setTimeout(() => {
      if (this.verSeparadoEnIva)
        this.sharedFunctions.setColumnsVisibility("Egresos", this.grid, this.gridColumns);
      else {
        this.sharedFunctions.setColumnsVisibility("EgresosNeto", this.grid, this.gridColumns);
        this.sharedFunctions.setColumnsVisibility("EgresosIva", this.grid, this.gridColumns);
      }

      if (this.searchForm.get("VerPorCuentaImputada")?.value == null || this.searchForm.get("VerPorCuentaImputada")?.value == false)
        this.sharedFunctions.setColumnsVisibility("CuentaImputadaCodigo", this.grid, this.gridColumns);

      this.data = new DataManager({
        url: this.movimientoService.searchReporteConsolidadoCajaUrl(),
        adaptor: new WebApiAdaptor(),
        headers: [this.movimientoService.getAuthorizationHeader(),this.movimientoService.getTenantHeader()]
      });
    }, 500);

    this.getSearchEstadisticas();
  }

  setPermissions() {
    this.menuService.checkMenu(MenuFuncionCodes.PROVEEDOR_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewProveedor = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.COMUNIDAD_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewComunidad = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.CONSORCIO_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewConsorcio = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success)
        this.canViewPersona = (data?.Result != null && data?.Result?.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success)
        this.canViewUf = (data?.Result != null && data?.Result?.length > 0);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

//#region Form

  buildForm() {
    var fechaHoy = new Date();
    var agrupador = this.isRosbaco ? ReporteConsolidadoCajaAgrupadorConstants.Comunidad : ReporteConsolidadoCajaAgrupadorConstants.Tenant;

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'CampoAgrupador': [agrupador],
      'MonedaConversionId': [null],
      'Proveedor': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'PersonaId': [null],
      'MonedaId': [null],
      'FechaDesde': [this.isRosbaco ? null : new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), 1)],
      'FechaHasta': [this.isRosbaco ? null : new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() + 1, 0)],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() + 1, 0)],
      'VerPorCuentaImputada': [null],
      'DescartarPendientes': [null],
      'VerBalancesNoCero': [null],
      'gridPage': [1],
      'OrderAscending': [true],
      'OrderFieldName': [null]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-reporteConsolidadoCaja");
    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.ComunidadId != null && filtros.ComunidadId > 0)
        this.onDeudaFiltroUfComunidadSelect(false);
    }
  }

//#endregion

//#region Search

  onSearch() {
    this.isSearching = true;

    this.searchForm.get('gridPage')?.setValue(1);
    this.searchForm.get('OrderAscending')?.setValue(true);
    this.searchForm.get('OrderFieldName')?.setValue(null);
    this.sharedFunctions.setReporteFiltros("app-reporteConsolidadoCaja", this.searchForm.getRawValue());

    this.setQueryParams();
    this.grid.refresh();

    this.getSearchEstadisticas();

    this.isSearching = false;
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "PersonaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PersonaId;
    else
      this.query.addParams("PersonaId",this.searchForm.value.PersonaId);

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "FechaDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaDesde", this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaHasta", this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "DescartarPendientes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.DescartarPendientes;
    else
      this.query.addParams("DescartarPendientes", this.searchForm.value.DescartarPendientes);

    index = this.query.params.findIndex(obj => obj.key === "VerPorCuentaImputada");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerPorCuentaImputada;
    else
      this.query.addParams("VerPorCuentaImputada", this.searchForm.value.VerPorCuentaImputada);

    index = this.query.params.findIndex(obj => obj.key === "VerBalancesNoCero");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerBalancesNoCero;
    else
      this.query.addParams("VerBalancesNoCero", this.searchForm.value.VerBalancesNoCero);

    index = this.query.params.findIndex(obj => obj.key === "CampoAgrupador");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.CampoAgrupador;
    else
      this.query.addParams("CampoAgrupador", this.searchForm.value.CampoAgrupador);

    index = this.query.params.findIndex(obj => obj.key === "MonedaConversionId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaConversionId;
    else
      this.query.addParams("MonedaConversionId",this.searchForm.value.MonedaConversionId);

    index = this.query.params.findIndex(obj => obj.key === "OrderAscending");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderAscending;
    else
      this.query.addParams("OrderAscending", this.searchForm.value.OrderAscending);

    index = this.query.params.findIndex(obj => obj.key === "OrderFieldName");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderFieldName;
    else
      this.query.addParams("OrderFieldName", this.searchForm.value.OrderFieldName);
  }

  getSearchEstadisticas() {
    var search = new SearchReporteConsolidadoCajaRequestDto(null, null, null, "", null, null, null, null, null, this.searchForm.value.Proveedor?.Id, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isStatisticsSearching = true;
    this.movimientoService.getReporteConsolidadoCajaEstadisticas(search).subscribe(data => {
      this.isStatisticsSearching = false;

      if (data.Success) {
        this.totalIngresos = data.Result.TotalIngresos;
        this.totalEgresos = data.Result.TotalEgresos;
        this.totalNetos = data.Result.TotalNetos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isStatisticsSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

//#endregion

//#region grid

  onActionBegin(args: any) {
    if (!this.isSearching) {
      if (args.requestType === 'paging') {
        this.searchForm.get('gridPage')?.setValue(args.currentPage);
        this.sharedFunctions.setReporteFiltros("app-reporteConsolidadoCaja", this.searchForm.getRawValue());
      }

      if (args.requestType === 'sorting') {
        this.searchForm.get('OrderAscending')?.setValue(args.direction=="Ascending");
        this.searchForm.get('OrderFieldName')?.setValue(args.columnName);
        this.sharedFunctions.setReporteFiltros("app-reporteConsolidadoCaja", this.searchForm.getRawValue());
      }
    }
  }

//#endregion

//#region getters

  getAgrupadores() {
    this.camposAgrupadoresList = [
      { Id: ReporteConsolidadoCajaAgrupadorConstants.Tenant, Nombre: this.sharedFunctions.getNombreMenuTenant("Tenant") },
      { Id: ReporteConsolidadoCajaAgrupadorConstants.Comunidad, Nombre: this.sharedFunctions.getNombreMenuTenant("Comunidad") }
    ];

    // if (!this.isRosbaco) {
    //   this.camposAgrupadoresList.push({ Id: ReporteConsolidadoCajaAgrupadorConstants.Proveedor, Nombre: this.sharedFunctions.getNombreMenuTenant("Proveedor") });
    //   this.camposAgrupadoresList.push({ Id: ReporteConsolidadoCajaAgrupadorConstants.Persona, Nombre: this.sharedFunctions.getNombreMenuTenant("Persona") })
    // }

    if (this.tenantFeatureFlags.HabilitarGestionUf)
      this.camposAgrupadoresList.push({ Id: ReporteConsolidadoCajaAgrupadorConstants.UnidadFuncional, Nombre: this.sharedFunctions.getNombreMenuTenant("UnidadFuncional") });

    if (this.tenantFeatureFlags.HabilitarGestionConsorcio)
      this.camposAgrupadoresList.push({ Id: ReporteConsolidadoCajaAgrupadorConstants.Consorcio, Nombre: this.sharedFunctions.getNombreMenuTenant("Consorcio") });

    this.camposAgrupadoresList = this.camposAgrupadoresList?.sort((a, b) => (a.Nombre > b.Nombre ? 1 : -1));
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onDeudaFiltroUfComunidadSelect(clearUf: boolean = true) {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    if (clearUf)
      this.searchForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

//#endregion

//#region Autocomplete

  getAutocompleteProveedor() {
    this.searchForm.get("Proveedor")?.valueChanges
    .pipe(
      filter(res => {
        if (res && res !== null && res.length >= 3) {
          this.isProveedorSearching = true;
          return true;
        }
        return false;
      }),
      distinctUntilChanged(),
      debounceTime(3000),
      tap(() => {
          this.filteredProveedorList = [];
      }),
      switchMap(value => this.proveedorService.search(new SearchProveedorRequest(50, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
        .pipe(
          finalize(() => {
            this.isProveedorSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      this.isProveedorSearching = false;
      if (data != null && data.result != null) {
        this.filteredProveedorList = data.result;
      }
      else
        this.filteredProveedorList = [];
    });
  }

//#endregion

//#region actions

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  viewProveedor(proveedorId: number) {
    if (proveedorId == null || proveedorId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewProveedor)
      this.router.navigate(['proveedores-edit', proveedorId]);
  }

  viewComunidad(comunidadId: number) {
    if (comunidadId == null || comunidadId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewComunidad)
      this.router.navigate(['comunidad-edit', comunidadId]);
  }

  viewConsorcio(consorcioId: number) {
    if (consorcioId == null || consorcioId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewConsorcio)
      this.router.navigate(['consorcio-edit', consorcioId]);
  }

  viewPersona(personaId: number) {
    if (personaId == null || personaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewPersona)
      this.router.navigate(['persona-edit', personaId]);
  }

  viewUf(ufId: number) {
    if (ufId == null || ufId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewUf)
      this.router.navigate(['unidad-funcional-edit', ufId]);
  }

  onExport() {
    var search = new SearchReporteConsolidadoCajaRequestDto(null, null, null, "", null, null, null, null, null, this.searchForm.value.Proveedor?.Id, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.movimientoService.exportReporteConsolidadoCaja(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReporteConsolidadoCaja_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onExportDetalles() {
    var search = new SearchReporteConsolidadoCajaRequestDto(null, null, null, "", null, null, null, null, null, this.searchForm.value.Proveedor?.Id, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExportingDetalles = true;
    this.movimientoService.exportReporteConsolidadoCajaConDetalles(search).subscribe((data: Blob) => {
      this.isExportingDetalles = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReporteConsolidadoCaja-Detalles_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExportingDetalles = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  isProcessing() {
    return (this.isSearching || this.isExporting || this.isExportingDetalles);
  }

  openDialogDetalleMovimientos(item: any) {
    var request = this.searchForm.getRawValue();

    var monedaConversionId = this.searchForm.get("MonedaConversionId")?.value;
    if (monedaConversionId == null || monedaConversionId <= 0)
      request.MonedaId = item.MonedaOriginalId;

    if (item.CuentaImputadaId != null && item.CuentaImputadaId > 0)
      request.CuentaImputadaId = item.CuentaImputadaId;

    switch (request.CampoAgrupador)
    {
      case ReporteConsolidadoCajaAgrupadorConstants.Tenant:
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Comunidad:
        request.ComunidadId = item.ConceptoId;
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Consorcio:
        request.ConsorcioId = item.ConceptoId;
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Proveedor:
        request.ProveedorId = item.ConceptoId;
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Persona:
        request.PersonaId = item.ConceptoId;
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.UnidadFuncional:
        request.UnidadFuncionalId = item.ConceptoId;
        break;
    }

    const dialogRef = this.dialog.open(DialogDetalleMovimientosConsolidadoCajaComponent, {
      data: new DialogDetalleMovimientosConsolidadoCajaRequestDto(request, item)
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });
  }

  filtroEstaAgrupadoPorTenant() {
    return (this.searchForm.value?.CampoAgrupador == ReporteConsolidadoCajaAgrupadorConstants.Tenant);
  }

  viewDetail(item: any) {

    switch (this.searchForm.value?.CampoAgrupador)
    {
      case ReporteConsolidadoCajaAgrupadorConstants.Tenant:
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Comunidad:
        this.viewComunidad(item.ConceptoId);
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Consorcio:
        this.viewConsorcio(item.ConceptoId);
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Proveedor:
        this.viewProveedor(item.ConceptoId);
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.Persona:
        this.viewPersona(item.ConceptoId);
        break;
      case ReporteConsolidadoCajaAgrupadorConstants.UnidadFuncional:
        this.viewUf(item.ConceptoId);
        break;
    }
  }

  pageGrid() {
    this.gridAllowPaging = !this.gridAllowPaging;
  }

  onChangeVerSeparadoEnIva() {
    this.onSearch();

    this.sharedFunctions.setColumnsVisibility("Egresos", this.grid, this.gridColumns);
    this.sharedFunctions.setColumnsVisibility("EgresosNeto", this.grid, this.gridColumns);
    this.sharedFunctions.setColumnsVisibility("EgresosIva", this.grid, this.gridColumns);
  }

  onChangeVerCuentaImputada() {
    this.onSearch();
    this.sharedFunctions.setColumnsVisibility("CuentaImputadaCodigo", this.grid, this.gridColumns);
  }
//#endregion
}
